<ol class="breadcrumb">
  <li class="breadcrumb-item"><a routerLink="/locations">Locations</a></li>
  <li class="breadcrumb-item active">Add Collection</li>
</ol>

<div>
  <form class="form-horizontal col col-sm-6" >
    <table class="table table-striped">
      <tbody>
        <tr>
          <th>Collection Name</th>
          <td>
            <input type="text"
                  class="form-control"
                  name="name"
                  [(ngModel)]="locationCollection.name"
                  placeholder="Name">
          </td>
        </tr>
      </tbody>
    </table>
    
    <div class="action-wrap text-left">
      <button type="button" class="btn btn-default" routerLink="/locations">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="addLocationCollection()">Save</button>
    </div>
  </form>
</div>
  